import React from 'react';
import PageWrapper from '../../components/UI/PageWrapper';
import RolesList from '../../components/Admin/RolesList';

const RolesListPage = () => (
  <PageWrapper>
    <RolesList />
  </PageWrapper>
);

export default RolesListPage;

